<template>
  <div id="login">
    <div class="headerBox">
        <!-- <p style="color: #303030;">{{$AppName}}</p> -->
    </div>
    <div class="contentBox">
    	<div class="content">
    		<div class="fl_left conLogo">
                <!-- <el-carousel height="590px">
                    <el-carousel-item v-for="(item,key) in imgUrl" :key="key">
                        <img :src="item" alt="">
                    </el-carousel-item>
                </el-carousel> -->
            </div>
    		<div class="fl_right conRight" v-if="loginShow">
                <div class="title">登录</div>
                <div class="conList">
                    <input type="text" name="" v-model="name" placeholder="账户">
                </div>
                <div class="conList">
                    <input type="password" name="" v-model="pass" placeholder="密码">
                </div>
                <div class="conList">
                    <input type="text" name="" v-model="code" placeholder="验证码" @keyup.enter="login">
                    <div class="phoImg" @click="getcode">
                        <img :src="codeImg">
                    </div>
                </div>
                <div class="login_wrap clearfix">
                    <!-- <div class="fl_left" style="text-align:right;color:#c30d23;cursor:pointer;padding-top:10px;" @click="findPas">找回密码</div> -->
                    <!-- <div class="forget_pwd">忘记密码？</div> -->
                    <div class="login fl_right" @click="login">登录</div>
                </div>
                <div class="" style="text-align:left;color:#c30d23;cursor:pointer;margin-bottom:45px;line-height:35px;" @click="findPas">找回密码?</div>
                <div style="font-size: 12px;">为了保证功能的正常使用，请下载<span class="goole">谷歌浏览器</span></div>
                <div style="font-size: 12px;"><a href="https://bw-bda.oss-cn-beijing.aliyuncs.com/public/chrome.exe" target="_blank" style="display:inline;">windows 电脑</a> | <a href="https://bw-bda.oss-cn-beijing.aliyuncs.com/public/chrome.dmg" style="display:inline;" target="_blank">苹果mac电脑</a></div>
    		</div>
            <div class="fl_right conRight" v-else>
                <div style="color:#666;cursor:pointer;padding-bottom:20px;" @click="findLogin">登录</div>
                <div class="title">找回密码</div>
                <div class="conList">
                    <input type="text" name="" v-model="phone" placeholder="账户/手机号">
                </div>
                <div class="conList" style="position: relative;">
                    <input type="text" name="" v-model="smscode" placeholder="验证码" @keyup.enter="sure">
                    <button class="codeBtn">
                       <span v-if="counts==0" @click="handCode">获取验证码</span>
                       <span v-else class="count">{{counts}} s</span>
                    </button>
                </div>
                <div class="conList">
                    <input type="password" name="" v-model="phopass" placeholder="密码">
                </div>
                <div class="login_wrap clearfix">
                    <!-- <div class="forget_pwd">忘记密码？</div> -->
                    <div class="login fl_right" @click="sure">确定</div>
                </div>
            </div>
    		<div class="clear"></div>
    	</div>
    </div>
    <!-- <div class="footerBox">
    	<div class="footText">{{$AppName}}</div>
    </div> -->
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  export default {
    name: 'login',
    data () {
      return {
        smscode:'',
        phone:'',
        name:'',
        pass:'',
        code:'',
        codeImg:'',
        imgUrl:["./static/imgs/login_img01.png","./static/imgs/login_img02.png","./static/imgs/login_img03.png"],
        key:'',
        counts:'',
        smskey:'',
        loginShow:true,
        phopass:'',
      }
    },
    methods:{
        ...mapMutations(['changeLogin']),
        getcode(){
            let _this = this;
    	    _this.$axios.post('getcaptcha',{}).then(res=>{
    	        _this.codeImg = res.data.data.img;
                _this.key = res.data.data.key;
    	    }).catch(function (error) {
    	      console.log(error);
    	    });
        },
        findLogin(){
            this.name='';
            this.pass='';
            this.code='';
            this.loginShow=true;
        },
        findPas(){
            this.phopass='';
            this.smscode='';
            this.phone='';
            this.loginShow=false;
        },
        handCode(){
            let _this=this;
            let pattern=/^1[3456789]\d{9}$/;//手机号验证
            if(_this.phone==''){
                this.$Message.error('请输入手机号');
            }
            else if(pattern.test(_this.phone)==false){
                this.$Message.error('手机号输错了');
            }
            else{
                _this.$axios.post('getsmscode',{
                    phone:_this.phone
                }).then(res=>{
                    if(res.data.code==200){
                        _this.smskey=res.data.data.smskey;
                        if (!_this.timer) {
                            _this.counts = 60;
                            _this.timer = setInterval(() => {
                              if (_this.counts > 0 && _this.counts <= 60) {
                                _this.counts--;
                              } else {
                                clearInterval(_this.timer);
                                _this.timer = null;
                              }
                            }, 1000)
                        }
                    }
                    else{
                        this.$Message.error(res.data.message)
                    }
                }).catch( function(response) {
                    console.log(response)
                });
            }
        },
        sure(){
            let _this=this;
            let pattern=/^1[3456789]\d{9}$/;//手机号验证
            if(_this.phone==''){
                this.$Message.error('请输入登录账户/手机号');
            }
            else if(pattern.test(_this.phone)==false){
                this.$Message.error('登录手机号输错了');
            }
            else if(_this.phopass==''){
                this.$Message.error('密码不能为空');
            }
            else if(_this.smscode==''){
                this.$Message.error('请输入验证码');
            }
            else{
                _this.$axios.post('changepassword',{
                    phone:_this.phone,
                    smscode:_this.smscode,
                    smskey:_this.smskey,
                    new_pwd:_this.phopass
                }).then(res=>{
                    if(res.data.code==200){
                         this.$Modal.confirm({
                             title: '提示',
                             content: '<p>是否到登录页？</p>',
                             okText: '确定',
                             cancelText: '取消',
                             onOk: () => {
                                this.phopass='';
                                this.smscode='';
                                this.phone='';
                                this.name='';
                                this.pass='';
                                this.code='';
                                this.loginShow=true;
                             },
                             onCancel: () => {
                                this.phopass='';
                                this.smscode='';
                                this.phone='';
                                 // this.$Message.info('取消');
                             }
                         });
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            }
        },
        login(){
            let _this = this;
            if(_this.name == ''){
            	this.$message.error('账号不能为空');
            }
            else if(_this.pass == ''){
                this.$message.error('密码不能为空');
            }
            else{
                _this.$axios.post('login',{
                    phone:_this.name,
                    login_pwd:_this.pass,
                    captcha:_this.code,
                    key:_this.key,
                }).then(res=>{
                    //console.log(res)
                    if(res.data.code == 200){
                        localStorage.setItem('phone',res.data.data.phone)
                        _this.changeLogin({Authorization:res.data.data.token})
                        //console.log(res)
                        _this.$router.push({
                            path:'/manager'
                        })
                    }
                    else if(res.data.code == 502){
                        this.$message.error('验证码错误');
                       _this.getcode()
                    }
                    else{
                    	this.$message.error(res.data.message);
                       _this.getcode()
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            }
        }
    },
    created(){
        const _this = this;
        _this.getcode()
    }
  };
</script>
<style scoped>
	#login{
		width: 100%;
        height: 100%;
        /*background: url('../../static/imgs/login_bg.png') center center no-repeat;*/
        /*background-size: cover;*/
        /*min-width: 1200px;
        min-height: 900px;*/
        overflow: auto;
        position:fixed;
        top: 0;
        left: 0;
        background-color: #fafafa;
	}
	.headerBox{
        width: 884px;        
		height: 100px;
        background:transparent url('../../static/imgs/login_logo.png') 0  bottom/250px no-repeat;
        margin: 0 auto;
        /*padding-top: 78px;*/
	}
    .headerBox p{
        font-size: 28px;
        padding-left: 50px;
        color: #fff;
    }
 	.contentBox{
 		width: 100%;
		background-size: cover;
		padding-top: 36px;
		box-sizing: border-box;
 	}
 	.contentBox>img{
 		width: 100%;
 	}
 	.content{
 		width: 884px;
		height: 548px;
		background-color: rgba(255, 255, 255, .92);
		border-radius: 10px;
		margin: 0 auto;
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.1);
        overflow: hidden;
 	}
 	.conLogo{
 		width: 442px;
 		height: 100%;
 		background: url('../../static/imgs/login_img01.png') center center/100% no-repeat;
 	}
    .conLogo img{
        width: 100%;
        height: 100%;
    }
 	.conRight{
 		width:442px;
 		height: 496px;
 		/*border-left: 1px solid #ccc;*/
 		margin-top: 65px;
 		padding-left: 75px;
        padding-right: 77px;
 		box-sizing: border-box;
 	}
	.title{
		font-size: 18px;
		color: #000;
		line-height: 18px;
        margin-bottom: 30px;
        /*font-weight: bold;*/
        text-align: center;
	}
	.conList{
		width: 100%;
		height: 66px;
		padding-top: 16px;
		box-sizing: border-box;
		position: relative;
	}
	.conList>input{
		display: block;
		width: 100%;
		height: 50px;
		border: none;
		border-bottom: 1px solid #e6e6e6;
		background-color: rgba(0, 0, 0, 0);
		line-height: 50px;
		color: #000;
	}
	.conList>input:focus{
		border-bottom: 1px solid #c30d23;
	}
	.phoImg{
		width: 108px;
		height: 56px;
		position: absolute;
		top: 5px;
		right: 0;
		cursor: pointer;
	}
	.phoImg>img{
		width: 100%;
	}
    .login_wrap{
        margin: 30px 0 0;
        height: 46px;
        /*display: flex;
        justify-content: space-between;
        align-items: center;*/
    }
    .forget_pwd{
        font-size: 12px;
        color: #c30d23;
        cursor: pointer;
    }
	.login{
		width: 290px;
		height: 46px;
		background-color: #c30d23;
		border-radius: 2px;
		font-size: 14px;
		color: #fff;
		text-align: center;
		line-height: 46px;
		cursor: pointer;
	}
	.login:hover{
		background-color: #c30d23;
	}
 	.footerBox{
 		margin-top: 28px;
 	}
 	.footText{
 		font-size: 12px;
 		color: #fff;
 		text-align: center;
 	}
    .codeBtn{
        cursor:pointer;
        position: absolute;
        top: 2px;
        right: 0;
        width: 90px;
        height: 40px;
        background-color: #ffffff;
        border: solid 1px #dc4e5a;
        color: #dc4e5a;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        margin-top: 13px;
    }
    .goole{
        display: inline-block;
        text-indent: 28px;
        background: url('../../static/imgs/goole.png') left 5px center/18px no-repeat;
    }
</style>
<style>
    .el-carousel__indicator{
        display: inline-block;
        border-radius: 50%;
        width: 10px;
        height: 10px;
        background: #fff;
        padding: 0;

        margin: 0 5px;
        margin-bottom: 18px;
    }
    .el-carousel__button{
        width: 10px;
        height: 10px;
        border-radius: 50%;
    }

    .el-carousel__indicator.is-active button{
        background: #c30d23;
    }
</style>


// WEBPACK FOOTER //
// src/components/login.vue